export const maxStat = 255;
